import React from 'react';
export function ResourcesVideo() {
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8 border-b border-gray-100" data-id="element-212" data-mp="3vh98sjb45x9o">
      <div className="max-w-4xl mx-auto" data-id="element-213" data-mp="1gjzkp44kvlgb">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-8" data-id="element-214" data-mp="1ui5zh1xu4uq4">
          Videos &amp; Talks
        </h2>
        <p className="text-xl md:text-2xl text-brand-gray leading-relaxed mb-16" data-id="element-215" data-mp="1qeztzwijr7kp">
          Short demos, webinars, and guest appearances on AI transformation and
          team capability.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16" data-id="element-216" data-mp="1zfpkqlsya7rk">
          <div className="w-full aspect-video rounded-lg overflow-hidden shadow-lg border border-gray-100" data-id="element-217" data-mp="2e659ubohlzv0">
            <iframe src="https://www.youtube.com/embed/EAZu8C1HtO0" title="Videos & Talks - Episode 1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-218" data-mp="296aiy84ppa9y"></iframe>
          </div>

          <div className="w-full aspect-video rounded-lg overflow-hidden shadow-lg border border-gray-100" data-id="element-219" data-mp="1165gx717y0bw">
            <iframe src="https://www.youtube.com/embed/kNQ-K2ZHL4o" title="Videos & Talks - Episode 2" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-220" data-mp="164yxj8bsy7ga"></iframe>
          </div>
        </div>

        <div className="text-center" data-id="element-221" data-mp="1ow9n9m5ske6l">
          <a href="https://www.youtube.com/@Break-a-Pencil" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border-2 border-brand-navy text-lg font-bold rounded-lg text-brand-navy hover:bg-brand-navy hover:text-white transition-colors shadow-sm" data-id="element-222" data-mp="1oxavzjzc4ol5">
            See more on YouTube
          </a>
        </div>
      </div>
    </section>;
}